import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class MovuRobotics_ds_get_load_container_by_lookupcodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { loadContainerLookupCode: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, ModifiedSysDateTime?: string, StatusId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.loadContainerLookupCode)) {
      $missingRequiredInParams.push('\'loadContainerLookupCode\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      loadContainerLookupCode: string    }) {
        if(isNil($inParams.loadContainerLookupCode)) {
          return true; 
        }
      return false;
    }
}
